import { render, staticRenderFns } from "./SectionEvent.vue?vue&type=template&id=b1e6982a&scoped=true"
import script from "./SectionEvent.vue?vue&type=script&lang=js"
export * from "./SectionEvent.vue?vue&type=script&lang=js"
import style0 from "./SectionEvent.vue?vue&type=style&index=0&id=b1e6982a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e6982a",
  null
  
)

export default component.exports